angular.module('tradersyard').controller('graph.authentication.controller', [
    '$scope',
    'graph-report-service',
    'graph-email-guard',
    function ($scope, $service, $emailGuard) {
        $scope.pageView = 'signIn'; // possible 'signIn', 'signUp'

        $scope.opened = false;
        $scope.guestWebinarSignUp = false;
        $scope.formError = {};
        $scope.agreements = {};
        $scope.email = null;

        $scope.$on('open:authentication:dialog', function (event, pageView, webinarSignUp) {
            $scope.opened = true;
            $scope.guestWebinarSignUp = typeof webinarSignUp !== 'undefined' ? webinarSignUp : false;

            if (['signIn', 'signUp'].indexOf(pageView) !== -1) {
                $scope.pageView = pageView;
            }

            if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                $scope.$apply();
            }
        });

        $scope.closeDialog = function () {
            $scope.opened = false;
        };

        $scope.submitForm = function () {
            $scope.formError = {};

            var form = document.querySelector('#join-form');

            if (!$scope.agreements.privacy || !$scope.agreements.terms) {
                $scope.formError.agreements = true;
                return;
            }

            if (!window.grecaptcha.getResponse()) {
                $scope.formError.captcha = true;
                return;
            }

            // $emailGuard.checkEmail($scope.email)
            //     .catch(function(e) {
            //         form.submit();
            //     })
            //     .then(function(response) {
            //         if ($emailGuard.parseResponse(response) === 'yes') {
            //             $scope.formError.spam = true;
            //         } else {
            //             form.submit();
            //         }
            //     });

            form.submit();
        };

        document.addEventListener('keyup', function (e) {
            if (e.keyCode === 27 && $scope.opened) {
                $scope.opened = false;
                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.$apply();
                }
            }
        });
    },
]);
